// extracted by mini-css-extract-plugin
export var addButton = "_n8-0";
export var border = "_n8-8";
export var check = "_n8-h";
export var danger = "_n8-6";
export var dropdownContainer = "_n8-1";
export var editModalBody = "_n8-j";
export var footerContainer = "_n8-i";
export var fullWidth = "_n8-a";
export var hide = "_n8-9";
export var icon = "_n8-3";
export var input = "_n8-7";
export var inputFlex = "_n8-b";
export var inputWrapper = "_n8-c";
export var manualFocus = "_n8-5";
export var optionButton = "_n8-4";
export var pillWrapper = "_n8-e";
export var pointer = "_n8-2";
export var showOverflow = "_n8-f";
export var tagsFlex = "_n8-d";
export var xButton = "_n8-g";